import api from './api';

export const getAllPermissions = () => api.get('permissions');
export const createPermission = (permissionData: { name: string; display_name: string; module_id?: string; description?: string }) => api.post('permissions', permissionData);
export const updatePermission = (id: string, permissionData: { name: string; display_name: string; module_id?: string }) => api.put(`permissions/${id}`, permissionData);
